<script>
export default {
  data(){
    return {
      step: 1,
      guest_onboarding_seen: localStorage.getItem('guest_onboarding_seen') || false,
      data: [
        {
          title: "Добро пожаловать!",
          description: "Вы используете гостевой доступ. Он действует 7 дней.",
        },
        {
          title: "Доступно",
          description: "Вам доступен полный каталог программ, разделы «Языковая и тест. школа», «Международные гранты», «Полезное» и страница «Премиум опции».",
        },
        {
          title: "Закрыто",
          description: "Некоторые страницы и программы помечены замком. Чтобы их открыть — купите полную версию.",
        },
        {
          title: "Получите доступ",
          description: "Нажмите «Купить полную версию» в баннере, чтобы открыть весь функционал.",
        },
      ]
    }
  },
  methods:{
    navigate(type) {
      switch (type) {
        case 'next':
          if (this.step < 4) {
            this.step++;
          }
          break;
        case 'prev':
          if (this.step > 1) {
            this.step--;
          }
          break;
        case 'finish':
          this.guest_onboarding_seen = true;
          localStorage.setItem('guest_onboarding_seen', true);
          break;
        default:
          break;
      }
    }
  },
}
</script>

<template>
  <div 
    class="backdrop"
    v-if="$store.state.role === 'guest' && !guest_onboarding_seen"
  >
    <div class="modal">
      <img v-if="step == 1" src="@/assets/goodbye.png" alt="">
      <img v-else-if="step == 2" src="@/assets/checked.png" alt="">
      <img v-else-if="step == 3" src="@/assets/lock.png" alt="">
      <img v-else src="@/assets/key.png" alt="">
      <h2>
        {{ data[step-1].title }}
      </h2>
      <p>
        {{ data[step-1].description }}
      </p>
      <article class="modal__actions">
        <button
          v-if="step > 1"
          @click="navigate('prev')"
        >
          Предыдущая
        </button>
        <button
          v-if="step < 5 && step !== 4"
          @click="navigate('next')"
        >
          Следующая
        </button>
        <button
          v-else
          @click="navigate('finish')"
        >
          Закончить
        </button>
      </article>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.backdrop {
  position: fixed;
  inset: 0;
  z-index: 9000;
  background-color: rgba(173, 216, 230, 0.2);

  .modal {
    position: absolute;
    z-index: 9001;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
    max-width: 90%;
    max-height: 90%;
    overflow-y: auto;
    width: 70%;
    height: fit-content;
    padding: min(max(24px, calc(1.5rem + ((1vw - 7.68px) * 1.3889))), 40px);
    border-radius: min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;

    @media (min-width: 640px) {
      width: 50%;
    }
    @media (min-width: 768px) {
      width: 33%;
    }

    img {
      width: 120px;
    }
    
    p {
      font-size: min(max(14px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 16px);
      text-align: center;
    }

    &__actions {
      width: 100%;
      display: flex;
      justify-content: end;
      gap: 1rem;
      margin-top: 4rem;

      button {
        padding: 0.5rem;
        background-color: transparent;
        color: #11415D;
        border: none;
        border-radius: 10px;
        transition: all 0.3s ease;

        &:hover {
          background-color: #11415D;
          color: #fff;
          font-weight: 600;
        }
      }
    }
  }
}
</style>
